module.exports = __webpack_public_path__ + "static/media/view.5364c1ef.svg";